import React from "react"
import { Link } from "react-router-dom"
import * as moment from "moment"
import { Badge } from "reactstrap"

const formateDate = (date, format) => {
  const dateFormat = format ? format : "DD MMM Y"
  const date1 = moment(new Date(date)).format(dateFormat)
  return date1
}
const toLowerCase1 = str => {
  return str === "" || str === undefined ? "" : str.toLowerCase()
}
const ActiveValue = cell => {
  return cell && cell.value === true ?  <i className="mdi mdi-check-bold me-2 text-success"/> :  <i className="mdi mdi-close-thick me-2 text-danger"/>
}

const TableValue = cell => {
  return cell ? cell.value  : ""
}
const TableValueEmail = cell => {
  const currentRow = cell.row.original;
  return <>{currentRow.useremail}<i className={["mdi me-2" , currentRow.isEmailVerified ? " mdi-check-bold text-success" : " mdi-close-thick text-danger"].join(" ")} /></>
}
const Date = (cell) => {
  return (cell.value) ? moment(cell.value).format('YYYY-MM-DD') : '';
};

export { TableValue,ActiveValue,Date,TableValueEmail }
